import { url_base } from '../../config/url';
import axios from 'axios';

export async function startIncident({ eventId, supportUserId, supportUserName, supportReason }) {
    const result = await axios({
        method: 'put',
        url: `${url_base}/api/bluebuilding/event-incident/start`,
        data: { eventId, supportUserId, supportUserName, supportReason },
        headers: {
            Authorization: `JWT ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
        },
    });

    return result?.data;
}

export async function resolveIncident({ eventId, solutionComment }) {
    const result = await axios({
        method: 'put',
        url: `${url_base}/api/bluebuilding/event-incident/resolve`,
        data: { eventId, solutionComment },
        headers: {
            Authorization: `JWT ${localStorage.getItem('authToken')}`,
            'Content-Type': 'application/json',
        },
    });

    return result?.data;
}

